// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"_31aOt","footer":"lni2A","buttons":"_2IpBL","button":"_2DSWS"};